import { withStyles } from '@material-ui/core/styles';
import { TableCell } from '@material-ui/core';

const isDemo = process.env.REACT_APP_THEME === 'demo';

const CustomTableCell = withStyles((theme) => ({
  head: {
    padding: isDemo ? '4px 8px' : 8,
    textAlign: 'center',
  },
  body: {
    padding: isDemo ? '3px 8px' : '4px 8px',
    textAlign: 'center',
    ...(isDemo ? { borderBottom: '1px solid #ECECEC' } : {}),
  },
  footer: {
    padding: '4px 8px',
    textAlign: 'center',
  },
  root: {
    padding: isDemo ? '3px 8px' : 6,
  },
}))(TableCell);

export default CustomTableCell;
